<template>
  <el-dialog
    title="活动参加单位"
    :visible.sync="visible"
    top="29vh"
    width="500px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="单位名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入单位名称"
            maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="logo" prop="imgUploadList">
          <image-upload
            url="/api/achievement/uploadachiattach"
            accept="image/jpeg,image/png,image/bmp,image/webp,image/webp"
            :file-list.sync="form.imgUploadList"
            :num-limit="1"
            :size-limit="10"
            :multiple="false"
          >
            <template>
              <el-alert
                :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                type="warning"
              >
              </el-alert>
            </template>
          </image-upload>
        </el-form-item>
        <el-form-item label="选择属性" prop="categorys">
          <el-checkbox-group v-model="form.categorys">
            <el-checkbox label="1">合作单位</el-checkbox>
            <el-checkbox label="2">获奖单位</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <template v-if="companyId">
          <el-button type="primary" @click="handlerModifyData('ruleForm')"
            >修改
          </el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        name: "",
        imgUploadList: [], // imgURL 相对应
        categorys: []
      },
      rules: {
        name: [isEmpty("请输入单位名称")],
        imgUploadList: [isEmpty("请上传图片", "change")],
        categorys: [isEmpty("请选择属性")]
      },
      isLoading: false
    };
  },
  created() {
    if (this.companyId) {
      this.loadInfo();
    }
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        imgUploadList,
        categorys,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgURL = deconstruct(imgUploadList[0]);
      return {
        ...others,
        imgURL,
        categoryType: categorys.join(",")
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // 去分号
        imgURL,
        categoryType,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imgURL
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      return {
        ...others,
        ...turnFile,
        categorys:
          !(typeof categoryType === "string") ||
          categoryType === "" ||
          categoryType === null
            ? []
            : categoryType.split(",")
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("activity", "addCompany", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("activity", "addCompany", {
        ...params,
        id: this.companyId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      this.$api("activity", "getCompanyInfo", { id: this.companyId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.form = this.downloadProcessData(res.dataList[0]);
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped></style>
